import { render, staticRenderFns } from "./ReportDesignation.vue?vue&type=template&id=d5ff5e30&scoped=true&"
import script from "./ReportDesignation.vue?vue&type=script&lang=js&"
export * from "./ReportDesignation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ff5e30",
  null
  
)

export default component.exports